import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const RoundIcon = ({ icon: Icon, className, fillColor }) => {
  const cls = classNames(className);
  return (
    <div className={cls}>
      <Icon className="round-icon" fill={fillColor} />
    </div>
  );
};

RoundIcon.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  icon: PropTypes.object.isRequired,
  className: PropTypes.string,
  fillColor: PropTypes.string,
};

RoundIcon.defaultProps = {
  className: undefined,
  fillColor: 'green',
};

export default RoundIcon;
